import { render, staticRenderFns } from "./aftersale_apply_detail.vue?vue&type=template&id=014a723a&scoped=true"
import script from "./aftersale_apply_detail.vue?vue&type=script&lang=js"
export * from "./aftersale_apply_detail.vue?vue&type=script&lang=js"
import style0 from "./aftersale_apply_detail.vue?vue&type=style&index=0&id=014a723a&prod&lang=stylus&scoped=true"
import style1 from "./aftersale_apply_detail.vue?vue&type=style&index=1&id=014a723a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014a723a",
  null
  
)

export default component.exports